import { useEffect } from "react";
import { getConsent } from "@/components/CookieBanner";
import { trackPhoneConversion } from "@/lib/gtagConversion";

// Google Ads / gtag conversion tracking ID
const GA_ID = "AW-18117412144";
const STORAGE_KEY = "dds_cookie_consent_v1";
let injected = false;
let phoneListenerBound = false;

function bindPhoneListener() {
  if (phoneListenerBound) return;
  if (typeof document === "undefined") return;
  phoneListenerBound = true;
  // Global capture-phase listener: any click on a <a href="tel:..."> fires the conversion.
  document.addEventListener("click", (e) => {
    const anchor = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (anchor) trackPhoneConversion();
  }, true);
}

function injectGtag() {
  if (injected) return;
  if (typeof window === "undefined") return;
  injected = true;

  // 1) Inject the async external script tag
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  // 2) Initialize dataLayer + gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);

  // 3) Bind the tel: click listener once gtag is ready
  bindPhoneListener();
}

/**
 * Loads Google Ads gtag.js only if the user has explicitly consented to analytics cookies
 * (via the CookieBanner). Watches for consent changes and injects on grant.
 */
export default function GoogleAdsLoader() {
  useEffect(() => {
    if (getConsent().analytics === true) {
      injectGtag();
      return;
    }
    const onStorage = (e) => {
      if (e.key !== STORAGE_KEY) return;
      if (getConsent().analytics === true) injectGtag();
    };
    const interval = setInterval(() => {
      if (getConsent().analytics === true) {
        injectGtag();
        clearInterval(interval);
      }
    }, 1500);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener("storage", onStorage);
      clearInterval(interval);
    };
  }, []);
  return null;
}
